export const SAVE_DOCUMENTCASE_STARTED = "SAVE_DOCUMENTCASE_STARTED";
export const SAVE_DOCUMENTCASE_SUCCESS = "SAVE_DOCUMENTCASE_SUCCESS";
export const SAVE_DOCUMENTCASE_FAILED = "SAVE_DOCUMENTCASE_FAILED";


export const UPDATE_DOCUMENTCASE_STARTED = "UPDATE_DOCUMENTCASE_STARTED";
export const UPDATE_DOCUMENTCASE_SUCCESS = "UPDATE_DOCUMENTCASE_SUCCESS";
export const UPDATE_DOCUMENTCASE_FAILED = "UPDATE_DOCUMENTCASE_FAILED";


export const GET_ALLDOCUMENTCASE_STARTED = "GET_ALLDOCUMENTCASE_STARTED";
export const GET_ALLDOCUMENTCASE_SUCCESS = "GET_ALLDOCUMENTCASE_SUCCESS";
export const GET_ALLDOCUMENTCASE_FAILED = "GET_ALLDOCUMENTCASE_FAILED";

 
export const GET_ALLDOCUMENTCASE_BYID_STARTED = "GET_ALLDOCUMENTCASE_BYID_STARTED";
export const GET_ALLDOCUMENTCASE_BYID_SUCCESS = "GET_ALLDOCUMENTCASE_BYID_SUCCESS";
export const GET_ALLDOCUMENTCASE_BYID_FAILED = "GET_ALLDOCUMENTCASE_BYID_FAILED";

export const GET_ALLDOCUMENTCASE_BYUSER_STARTED = "GET_ALLDOCUMENTCASE_BYUSER_STARTED";
export const GET_ALLDOCUMENTCASE_BYUSER_SUCCESS = "GET_ALLDOCUMENTCASE_BYUSER_SUCCESS";
export const GET_ALLDOCUMENTCASE_BYUSER_FAILED = "GET_ALLDOCUMENTCASE_BYUSER_FAILED";
 
export interface IDocumentCase {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    CaseInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    permission_id: number;
    isLoading: boolean;
    error: string;
}
export const getAllDocumentCaseflowsByUserId = (companyId,userSelectAutoId) => {
 
     return {
         type: GET_ALLDOCUMENTCASE_BYUSER_STARTED ,
         payload: 'Value',
         input:companyId,
         inputparam:userSelectAutoId
     };
 };

 export const getAllDocumentCaseflows = (companyId) => {
 
    return {
        type: GET_ALLDOCUMENTCASE_STARTED ,
        payload: 'Value',
        input:companyId 
    };
};
 export const documentCaseCreate = (documentCaseCreateInput: any) => {
 
    return {
        type: SAVE_DOCUMENTCASE_STARTED,
        payload: 'status',
        input: documentCaseCreateInput
    };
};

export const documentCaseUpdate = (documentCaseUpdateInput: any) => {

   return {
       type: UPDATE_DOCUMENTCASE_STARTED,
       payload: 'status',
       input: documentCaseUpdateInput
   };
};

export const getAllDocumentCaseflowsById = (id) => {
 
    return {
        type: GET_ALLDOCUMENTCASE_BYID_STARTED ,
        payload: 'Value',
        input:id
    };
};